import { render, staticRenderFns } from "./failure-reason-column.vue?vue&type=template&id=55546005"
import script from "./failure-reason-column.vue?vue&type=script&lang=js"
export * from "./failure-reason-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports